/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-closed-caption-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.875 10.625h3.75v1.25h-3.75v-1.25zm-5 0h3.75v1.25h-3.75v-1.25zm-3.125 0h1.875v1.25H3.75v-1.25zm10-2.5h2.5v1.25h-2.5v-1.25zm-5.625 0H12.5v1.25H8.125v-1.25zm-4.375 0h3.125v1.25H3.75v-1.25zm7.335 10.625L10 18.125l2.5-4.375h3.75a1.248 1.248 0 001.25-1.25V5a1.248 1.248 0 00-1.25-1.25H3.75A1.248 1.248 0 002.5 5v7.5a1.248 1.248 0 001.25 1.25h5.625V15H3.75a2.5 2.5 0 01-2.5-2.5V5a2.5 2.5 0 012.5-2.5h12.5a2.5 2.5 0 012.5 2.5v7.5a2.5 2.5 0 01-2.5 2.5h-3.022l-2.143 3.75z"/>'
  }
})
